const formatInputNumberOnlyV2 = (val: any) => {
  if (/^0/.test(val)) {
    return String(val).replace(/^0/, "");
  } else {
    return String(val).replace(/\D+/g, "");
  }
};
export default formatInputNumberOnlyV2;
